import {
  Bar,
  BarChart,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis
} from 'recharts';
import MethodologyAnchor from '../MethodologyAnchor';
import { StyledRecharts } from './Recharts.styled';

const LeastWantedTechnologies: React.FC = () => {
  const data = [
    { language: 'AngularJS', value: 20.098039215686274, fill: '#08306B' },
    { language: '.NET', value: 15.849673202614378, fill: '#08306B' },
    { language: 'Angular2+', value: 13.725490196078432, fill: '#08519C' },
    { language: 'React', value: 10.620915032679738, fill: '#08519C' },
    { language: 'Windows', value: 8.49673202614379, fill: '#2171B5' },
    { language: 'WordPress', value: 8.333333333333332, fill: '#2171B5' },
    { language: 'jQuery', value: 7.026143790849673, fill: '#4292C6' },
    { language: 'CSS', value: 6.862745098039216, fill: '#4292C6' },
    { language: 'HTML', value: 5.065359477124183, fill: '#6BAED6' },
    { language: 'Vue', value: 3.9215686274509802, fill: '#6BAED6' }
  ];

  return (
    <div>
      <StyledRecharts className="dark">
        <ResponsiveContainer height={400}>
          <BarChart data={data} layout="vertical">
            <XAxis
              type="number"
              allowDecimals={false}
              tickLine={false}
              padding={{ left: 20 }}
              domain={[0, 40]}
            />
            <YAxis
              type="category"
              dataKey="language"
              tickLine={false}
              width={120}
            />
            <Tooltip
              cursor={{ fill: 'transparent' }}
              labelStyle={{ display: 'none' }}
              separator=""
              formatter={(value: number) => [value.toFixed(1) + '%', '']}
              wrapperClassName="tooltip-y"
            />
            <Bar dataKey="value" fill="fill" barSize={12} radius={5} />
          </BarChart>
        </ResponsiveContainer>
      </StyledRecharts>
      <MethodologyAnchor />
    </div>
  );
};

export default LeastWantedTechnologies;
